const emojisRegex = /\p{Emoji_Presentation}/u
const hasEmojis = (value: string): boolean => emojisRegex.test(value)
const removePrefix = (str: string, prefix: string) => (str?.startsWith(prefix) ? str.slice(prefix.length) : str)
const addPrefix = (str: string | undefined, prefix: string): typeof str => {
    if (!str) {
        return undefined
    }
    return str.startsWith(prefix) ? str : `${prefix}${str}`
}

export {removePrefix, addPrefix, hasEmojis}
